import { Poll } from '../../models/poll';
import { InvitePollService } from '../../services/invitepoll.service';
import { PollCompleterComponent } from '../poll-completer/poll-completer.component';
import { Component, OnInit, Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { PollService } from '../../services/poll.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {Observable} from "rxjs";
import { PollComponent } from '../poll/poll.component';
import { MessageBoxInviteDialog } from '../message-box-invite/message-box-invite.component';
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';

@Component({
  selector: 'app-poll-selector-dialog',
  templateUrl: './poll-selector-dialog.component.html',
  styleUrls: ['./poll-selector-dialog.component.css']
})
export class PollSelectorDialogComponent implements OnInit {
  publicating= false;
  @Input() UserID;
  @Input() JobID;
  @Input() JobName;
  @Input() nameComponent;
  createInvite= true;
  userId: string;
  errorMessage: string;
  offer_id: string;
  jobs: any;
  offername: any;
  jobId: string;
  premium: number;
  loading: boolean;
  poll: any;

  polls: Poll[];

  page: number;
  total: number;
  max: number;

  selectedOption: string;

  constructor(
    public dialogRef: MdDialogRef<PollSelectorDialogComponent>,
    private dialog: MdDialog, private router: Router,
    private invitePollService: InvitePollService,
    private pollService: PollService) {
  }

  ngOnInit() {
    this.loading = true;
    this.userId = this.UserID;
    this.loading = false;
    // let status = [];
    // this.offername = this.JobName;
    this.jobId = this.JobID;
    // if (this.JobID) {
    //   this.getOfferById(this.JobID);
    // }
    // status.push('1');
    // this.premium = 1;
    // this.JobOffersService.getOffers(undefined, undefined, status, 1, 1000000, this.premium)
    // .subscribe(
    //   data => {
    //     this.jobs = data.jobs;
    //     this.loading = false;
    //     // this.selectJobId();
    //   }
    // );
  }

  // selectJobId() {
  //   if (this.JobID) {
  //     this.jobId = this.JobID;
  //   }
  // }

  getPollById(id) {
    this.pollService.getPoll(id)
    .subscribe(
      data => {
        this.poll = data.polls[0];
        this.loading = false;
        // this.selectJobId();
      }
    );
  }

  openDialog (name, id) {
    let dialogRef = this.dialog.open(PollComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
      this.searchPolls(this.page);
    });
    dialogRef.componentInstance.nameComponent=name;
    dialogRef.componentInstance.PollID=id;
    dialogRef.componentInstance.Polls=this.polls;
}

searchPolls (page?: number, query?: string, active?: boolean, deleted?: boolean) {
  this.loading = true;
  const status = [];

  this.page = page;
  if (page == null) {
    page = 1;
  }

  if (active) {
      status.push('1');
  }

  if (deleted) {
      status.push('-6');
  }

  this.pollService.getPolls(page, this.max, 0, query, status)
  .subscribe(
  data => {
    this.polls = data.polls;
    this.total = data.pagination.total;
    this.loading = false;
  },
  error => {
    if (error.status == 404) {
      this.polls = undefined;
      this.loading = false;
    } else {
      console.log(error);
      this.polls = undefined;
      this.loading = false;
    }
  });
}

  getPollInput($event) {
    this.offername = $event.title;
    this.getPollById($event.id);

  }

  onPollInvite() {
    this.onPollPostInvite();
  }

  onPollPostInvite() {
    let invitations;
    if (this.jobId) {
      invitations = [{
        'job_id': this.jobId,
        'user_id': this.userId}];
    } else {
      if (this.JobID !== null) {
        invitations = [{
          'job_id': this.JobID,
          'user_id': this.userId}];
      }
    }
    console.log(this.poll);
    this.invitePollService.postPollInvite(this.jobId, this.poll.id)
      .subscribe(
        data => {
          this.dialogRef.close(data);
          this.dialog.open(MessageBoxInviteDialog, {data: {data: data, success: true, showIcon:true}});
        },
        error => {
          let txterrors: string = error;
          let jsonErrors: any =  [];
          jsonErrors =  JSON.parse(txterrors).errors;
          txterrors = '';
          if (jsonErrors.length > 0){
            jsonErrors.forEach(function(element, index) {
                let err: any;
                let txterr = "";
                for(err in element.errors){
                  txterr = txterr+" "+element.errors[err][0];
                }
                txterrors = txterrors+"<p class='bg-danger'>"+txterr+"</p>";

            });
          }else{
                txterrors = "<p class='bg-danger'>no hubo errores</p>"
          }
          this.publicating = false;
          this.errorMessage = <any>error

          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', html: txterrors, alert: true, showIcon: true}});
        }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/poll-selector-dialog/poll-selector-dialog.component.ts